//inquiry
export const inquiryeHeaderData = [
  { text: 'Number', value: 'num', widthClass: 'iqIdxWidth' },
  { text: 'Title', value: 'title', widthClass: 'iqTitleWidth' },
  { text: 'Writer', value: 'writer', widthClass: 'iqWidth' },
  { text: 'Date', value: 'date', widthClass: 'iqWidth' },
  { text: 'Status', value: 'status', widthClass: 'iqWidth' },
]

export const inqMobileHeaderData = [
  { text: 'Number', value: 'num', widthClass: 'iqIdxWidth' },
  { text: 'Title', value: 'title', widthClass: 'iqTitleWidth' },
]

export const inquiryOptions = [
  { label: '제목', value: 'T' },
];


//notice
export const noticeHeaderData = [
  { text: 'Number', value: 'num', widthClass: 'ntIdxWidth' },
  { text: 'Title', value: 'title', widthClass: 'ntTitleWidth' },
  { text: 'Writer', value: 'writer', widthClass: 'ntTableBorderHd' },
  { text: 'Date', value: 'date', widthClass: 'ntTableBorderHd' },
]

export const noticeOptions = [
  { label: '전체', value: 'A' },
  { label: '제목', value: 'T' },
  { label: '내용', value: 'C' },
];


//buy
export const buyHeaderData = [
  { text: '번호', value: 'num', widthClass: 'bIdxWidth' },
  { text: '업체명', value: 'title', widthClass: 'bTitleHWidth' },
  { text: '결제여부', value: 'status', widthClass: 'bWidth' },
  { text: '작성일', value: 'date', widthClass: 'bWidth' },
]

export const buyOptions = [
  { label: '업체명', value: 'T' },
];


//reference
export const refOptions = [
  { label: 'ALL', value: 'A' },
];